import type { ErrorMessage } from '@/types/base'
import { defineStore } from 'pinia'
import { Ref, ref } from 'vue'

export interface UseErrorStoreReturn {
    error: Ref<ErrorMessage>
    sendError: (newError: ErrorMessage) => void
    clearError: () => void
}
export const useErrorStore = defineStore('errorStore', (): UseErrorStoreReturn => {
    const error = ref<ErrorMessage>({ show: false, message: '' })
    function sendError(newError: ErrorMessage) {
        if (!error?.value) return
        error.value.show = true
        error.value.message = newError.message
    }
    function clearError() {
        if (!error?.value) return
        error.value.show = false
    }
    return { error, sendError, clearError }
})
